<template>
  <div>
    <div class="spinner-wrapper">
      <div class="spinner"></div>
    </div>
    <div v-if="showOverlay" class="overlay"></div>
  </div>
</template>

<script>
export default {
  name: "base-page-spinner-new",
  props: {
    showOverlay: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.spinner-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #ffffff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 9998;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>